import { render, staticRenderFns } from "./PasswordEmail.vue?vue&type=template&id=14725496"
import script from "./PasswordEmail.vue?vue&type=script&lang=js"
export * from "./PasswordEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports